// Configurações de SEO centralizadas
export const seoConfig = {
  // Informações da empresa
  company: {
    name: "PH Móveis Artesanais",
    description: "Móveis artesanais únicos em madeiras nobres brasileiras. Tradição artesanal, design contemporâneo e personalização completa.",
    url: "https://phmoveis.com.br",
    logo: "https://phmoveis.com.br/assets/logo.png",
    phone: "+55-62-99326-3202",
    email: "phmoveisconteporaneos@gmail.com",
    address: {
      street: "Rua dos Artesãos, 123",
      city: "São Paulo",
      state: "SP",
      zipCode: "05435-000",
      country: "BR"
    },
    coordinates: {
      latitude: -23.5505,
      longitude: -46.6333
    },
    socialMedia: {
      instagram: "https://www.instagram.com/phmoveisartesanais",
      facebook: "https://www.facebook.com/phmoveisartesanais",
      whatsapp: "https://wa.me/5562993263202"
    }
  },

  // Palavras-chave principais
  keywords: {
    primary: [
      "móveis artesanais",
      "móveis personalizados", 
      "madeira nobre",
      "móveis sob medida",
      "marcenaria artesanal",
      "móveis brasileiros",
      "design contemporâneo"
    ],
    secondary: [
      "ipê",
      "cumaru", 
      "teca",
      "peroba",
      "móveis de madeira",
      "marcenaria",
      "artesanato",
      "sustentabilidade",
      "madeira certificada"
    ],
    location: [
      "São Paulo",
      "SP",
      "Brasil",
      "móveis São Paulo",
      "marcenaria São Paulo"
    ]
  },

  // Configurações de páginas
  pages: {
    homepage: {
      title: "Móveis Únicos, Feitos Especialmente para Você",
      description: "Móveis artesanais únicos em madeiras nobres brasileiras. Tradição artesanal, design contemporâneo e personalização completa. Consultoria gratuita e garantia vitalícia.",
      keywords: "móveis artesanais, móveis personalizados, madeira nobre, móveis sob medida, marcenaria artesanal, móveis brasileiros, design contemporâneo, ipê, cumaru, teca, peroba, móveis de madeira, marcenaria, artesanato"
    },
    about: {
      title: "Sobre Nós | Tradição e Excelência em Marcenaria",
      description: "Conheça a história da PH Móveis Artesanais, nossos mestres artesãos e nossa filosofia de criar móveis únicos que contam histórias. 25 anos de tradição em marcenaria brasileira.",
      keywords: "sobre ph móveis, história marcenaria, artesãos brasileiros, móveis artesanais, tradição, qualidade, sustentabilidade, empresa familiar, marcenaria artesanal, móveis personalizados"
    },
    catalog: {
      title: "Catálogo Interativo | Móveis Artesanais Únicos",
      description: "Explore nossa coleção exclusiva de móveis artesanais únicos em madeiras nobres brasileiras. Filtros avançados, visualização 3D e personalização completa.",
      keywords: "catálogo móveis artesanais, móveis personalizados, madeira nobre, ipê, cumaru, teca, peroba, móveis sob medida, marcenaria artesanal, design contemporâneo"
    },
    process: {
      title: "Processo Artesanal | Tradição e Excelência em Marcenaria",
      description: "Conheça nosso processo artesanal completo: da seleção da madeira premium ao acabamento final. Artesãos especializados, técnicas tradicionais e qualidade garantida.",
      keywords: "processo artesanal, móveis artesanais, marcenaria, madeira premium, artesãos, qualidade, sustentabilidade, técnicas tradicionais, madeira certificada"
    },
    gallery: {
      title: "Galeria de Projetos | Inspiração em Móveis Sob Medida",
      description: "Explore nossa galeria com mais de 150 projetos realizados. Veja transformações reais, depoimentos de clientes e inspire-se para seu próximo projeto de móveis sob medida.",
      keywords: "galeria projetos móveis, antes e depois móveis, depoimentos clientes, projetos residenciais, móveis sob medida São Paulo, transformações, inspiração, design de interiores"
    },
    contact: {
      title: "Contato & Consultoria | Agende Sua Consultoria Gratuita",
      description: "Agende sua consultoria gratuita para móveis artesanais personalizados. Atendimento via WhatsApp, telefone ou presencial em São Paulo.",
      keywords: "consultoria móveis, móveis personalizados, artesanais, São Paulo, WhatsApp, showroom, agendamento, consultoria gratuita"
    },
    materials: {
      title: "Materiais Premium | Madeiras Nobres Brasileiras",
      description: "Conheça as madeiras nobres e materiais premium que utilizamos em nossos móveis artesanais. Ipê, Cumaru, Teca, Peroba e muito mais.",
      keywords: "materiais premium, madeiras nobres, ipê, cumaru, teca, peroba, madeira brasileira, sustentabilidade, certificação FSC, madeira certificada"
    }
  },

  // Configurações de Open Graph
  openGraph: {
    type: "website",
    locale: "pt_BR",
    siteName: "PH Móveis Artesanais",
    imageWidth: 1200,
    imageHeight: 630
  },

  // Configurações de Twitter
  twitter: {
    card: "summary_large_image",
    site: "@phmoveisartesanais",
    creator: "@phmoveisartesanais"
  },

  // Configurações de performance
  performance: {
    // Lazy loading para imagens
    lazyLoading: true,
    // Preload de recursos críticos
    preloadCritical: true,
    // Compressão de imagens
    imageOptimization: true,
    // Minificação de CSS/JS
    minification: true
  },

  // Configurações de analytics
  analytics: {
    googleAnalytics: "GA_MEASUREMENT_ID",
    googleTagManager: "GTM_CONTAINER_ID",
    facebookPixel: "FACEBOOK_PIXEL_ID"
  }
};

// Função para gerar dados estruturados padrão
export const generateDefaultStructuredData = (pageType = "website", customData = {}) => {
  const baseData = {
    "@context": "https://schema.org",
    "@type": pageType,
    "name": seoConfig.company.name,
    "description": seoConfig.company.description,
    "url": seoConfig.company.url,
    "telephone": seoConfig.company.phone,
    "email": seoConfig.company.email,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": seoConfig.company.address.street,
      "addressLocality": seoConfig.company.address.city,
      "addressRegion": seoConfig.company.address.state,
      "postalCode": seoConfig.company.address.zipCode,
      "addressCountry": seoConfig.company.address.country
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": seoConfig.company.coordinates.latitude,
      "longitude": seoConfig.company.coordinates.longitude
    },
    "openingHours": "Mo-Fr 08:00-18:00, Sa 08:00-14:00",
    "priceRange": "$$$",
    "sameAs": [
      seoConfig.company.socialMedia.instagram,
      seoConfig.company.socialMedia.facebook
    ]
  };

  return { ...baseData, ...customData };
};

// Função para gerar meta tags de performance
export const generatePerformanceMeta = () => {
  return [
    { name: "viewport", content: "width=device-width, initial-scale=1.0, viewport-fit=cover" },
    { name: "theme-color", content: "#8B4513" },
    { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" },
    { name: "googlebot", content: "index, follow" }
  ];
};

// Função para gerar preconnect links
export const generatePreconnectLinks = () => {
  return [
    { rel: "preconnect", href: "https://fonts.googleapis.com" },
    { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: true },
    { rel: "dns-prefetch", href: "//images.unsplash.com" },
    { rel: "dns-prefetch", href: "//wa.me" }
  ];
};
